module.exports = __webpack_public_path__ + "static/media/Warning.075992c9.svg";